angular.module('angus.controllers').directive('purchaseOrders', function() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'templates/tankMonitor/inventoryManagement/purchaseOrders/purchaseOrderView.html'
    };
});
  